import axios from '@/backend/axios'

export default {
  async login(credentials) {
    return await axios.post('/account/login', credentials)
  },
  async loginAdmin(credentials){
    return await axios.post('/v2/admin/login', credentials)
  },

  async validate(token){
    const req= {token:token}
    return await axios.post('account/validate',req)
    //.then((response) => {
  //     console.log('Validate respo:' + response.data)
  //     return response
  //  })
  },

  async validateAdmin(token){
    const req= {token:token}
    return await axios.post('/v2/admin/validate',req)
    //.then((response) => {
  //     console.log('Validate respo:' + response.data)
  //     return response
  //  })
  },
  async refresh(oldToken, refreshToken){
    var req = {
      token: oldToken,
      refreshToken: refreshToken, 
    }
    return await axios.post('account/validate',req)
  },
  async adminGetMessages() {
    return await axios.get('messages')
  },
  async adminSaveMessage(message) {
    return await axios.post('messages',message)
  },
  async adminDeleteMessage(message) {
    return await axios.post('messages/delete',message)
  },
  async adminSaveMessageToCustomer(id, customers){
    var req = JSON.stringify(customers)
    return await axios.post(`messages/${id}/add`,req)
  },
  async adminGetCustomersForMessage(id){    
    return await axios.get(`messages/${id}/customers`)
  },
  async adminUploadDailyProduct(formData){    
    return await axios.post('dailyproduct/upload',formData)
  },
  async adminGetDailyProducts(publisher){    
    return await axios.get(`/dailyproduct/products/${publisher}`)
  },
  async adminGetDailyProductsNotPublished(){    
    return await axios.get('/dailyproduct/products/not-published')
  },
  async adminGetBundleBlocks(customerId){
    return await axios.get(`/bundle/${customerId}/blocks`)
  },
  async adminDeleteBundleBlocks(customerId,bundleId){
    return await axios.delete(`/bundle/${customerId}/blocks/${bundleId}`)
  },
  async adminGetChangeableBundles(customerId){
    return await axios.get(`/bundle/change/customer/${customerId}`)
  },
  async adminChangeBundle(customerId,bundle){
    return await axios.post(`/bundle/${bundle.id}/change/customer/${customerId}`,bundle)
  },
  async adminGetBundle(customerId,startDate,stopDate) {
    return await axios.get(`/bundle/customer/${customerId}/${startDate}/${stopDate}`)
  }, 
  async adminSaveDescription(formData){    
    return await axios.post('paper/description',formData)
  },
  async adminSaveShortcut(formData){    
    return await axios.post('admin/shortcut/add',formData)
  },
  async adminGetShortcuts(){    
    return await axios.get('admin/shortcuts')
  },
  async adminDeleteShortcut(id){    
    return await axios.delete(`admin/shortcut/${id}`)
  },
  async adminGetHolidayList(){    
    return await axios.get('holiday')
  },
  async adminGetHolidays(){    
    return await axios.get('holiday/admin/list')
  },

  async adminCompleteHoliday(id){    
    return await axios.post(`holiday/admin/complete/${id}`)
  },
  async adminDeleteHoliday(id){    
    return await axios.delete(`holiday/admin/${id}`)
  },
  async adminAddHoliday(holiday){        
    return await axios.post('holiday/admin/save',holiday)
  },
  async adminGetProductInformations(provider) {
    return await axios.get(`/admin/products/${provider}`)
  },
  async adminSaveProductInformation(product) {
    return await axios.post('admin/products/save',product)
  },
  async deleteProductInformation(product){
    return await axios.delete(`admin/products/${product.id}`)
  },
  async adminAddInvoice(invoice){
    return await axios.post('invoice/invoiceData/add',invoice)
  },
  async adminGetExtraInvoice(){
    return await axios.get('invoice/invoiceData/list')
  },
  async adminDeleteExtraInvoice(invoiceData){
    return await axios.delete(`invoice/invoiceData/${invoiceData.id}`)
  },
  async adminGetGuarantees(){
    return await axios.get('guarantee')
  },
  async adminGetGuaranteeTotals(){
    return await axios.get('guarantee/total')
  },
  async adminGetGuaranteesByCustomerNumber(customerNumber){
    return await axios.get(`guarantee/${customerNumber}`)    
  },
  async adminSendRefunds(guarantees){
    return await axios.post('guarantee',guarantees)
  },
  async adminGetReceipts(guarantees){
    return await axios.post('guarantee/underlag/all',guarantees)
  },
  async adminGetReceipt(guarantee){
    return await axios.post('guarantee/underlag',guarantee)
  },
  async adminSetGuaranteeCompleted(guarantees){
    return await axios.post('guarantee/completed',guarantees)
  },
  async adminSaveRefunds(refundedGuarantees) {
    // POST or PUT depending on your backend
    return await axios.post('guarantee/refunds/save', refundedGuarantees)
  },

  async adminGetSavedRefunds() {
    // GET the saved refunds for the current user/session
    return await axios.get('guarantee/refunds/saved')
  },
   async adminUpdateRefunds(refundedGuarantees) {
    // GET the saved refunds for the current user/session
    return await axios.put('guarantee', refundedGuarantees)
  },

  async adminUpdateBankgiro({ customerNr, bankgiro }) {
    // Update bankgiro for a specific customer
    return await axios.post(`/guarantee/${customerNr}/bankgiro/update/${bankgiro}`,  bankgiro )
  },
  async adminUpdateBankaccount({ customerNr, bankaccount }) {
    // Update bankaccount for a specific customer
    return await axios.post(`/guarantee/${customerNr}/bankaccount/update/${bankaccount}`,  bankaccount )
  },
  async adminUpdateOrgnumber({ customerNr, orgnumber }) {
    // Update bankgiro for a specific customer
    return await axios.post(`/guarantee/${customerNr}/orgnumber/update/${orgnumber}`,  orgnumber )
  },

   async adminUploadInvoice(invoiceData) {
    // Update bankgiro for a specific customer
     return await axios.post('invoice/upload',invoiceData)
  },
  async adminGetUploadedInvoice() {
    // Update bankgiro for a specific customer
     return await axios.get('invoice/upload/list')
  },
  async adminTransferUploadToInvoice() {
    // Update bankgiro for a specific customer
     return await axios.post('invoice/upload/transfer')
  },
   async adminDeleteUploadedInvoice(invoiceData){
    return await axios.delete(`invoice/upload/${invoiceData.id}`)
  },
  async adminDeleteUploadedInvoiceFile(invoiceFileId){
    return await axios.delete(`invoice/upload/all/${invoiceFileId}`)
  },
  async adminAddGuanranteeInvoice(guaranteeInvoice) {
    return await axios.post('guarantee/refunds/invoice/save',guaranteeInvoice)
  },

  async adminUploadExtraInvoice(formData) {
    return await axios.post('invoice/extra-invoice/upload-csv', formData)
  },

  async adminGetMiniDeb() {
    return await axios.get('minideb')
  },
  async adminSaveMiniDeb(entry) {
    return await axios.post('minideb/save', entry)
  },
  async adminDeleteMiniDeb(customerNr) {
    return await axios.delete(`minideb/${customerNr}`)
  }
}